import React from 'react';
import { motion } from 'framer-motion';
import { SectionMarker } from './SectionMarker';
export function WhyNothingWorksSection() {
  return <section className="w-full bg-navy-dark py-10 md:py-14" data-id="element-215">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-216">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-10" data-id="element-217">
          <div className="flex items-center justify-center gap-3 mb-6" data-id="element-218">
            <SectionMarker data-id="element-219" />
            <span className="text-cream-muted text-sm uppercase tracking-wider" data-id="element-220">
              Por qué lo que has probado no funciona
            </span>
          </div>

          <h2 className="font-playfair text-3xl md:text-4xl lg:text-5xl font-bold text-cream mb-4" data-id="element-221">
            El error no es tu disciplina.
          </h2>

          <p className="font-playfair text-xl md:text-2xl italic text-amber" data-id="element-222">
            Es que estás atacando el lugar equivocado.
          </p>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6,
        delay: 0.2
      }} className="space-y-6 text-lg text-cream-muted leading-relaxed" data-id="element-223">
          <p className="text-cream text-xl font-medium" data-id="element-224">
            El insomnio no empieza en el sueño.
          </p>

          <p className="text-xl text-amber font-medium" data-id="element-225">
            Empieza en el sistema nervioso.
          </p>

          <p data-id="element-226">
            Las pastillas pueden sedarte. Los tés pueden relajarte. La fuerza de
            voluntad puede forzarte.
          </p>

          <p data-id="element-227">
            Pero ninguna de esas cosas le enseña a tu cuerpo que ya no hay
            peligro.
          </p>

          <p className="text-cream" data-id="element-228">Y mientras el cuerpo sienta peligro…</p>
        </motion.div>

        <motion.p initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6,
        delay: 0.4
      }} className="mt-8 font-playfair text-2xl md:text-3xl font-bold text-amber text-center" data-id="element-229">
          No va a soltar.
        </motion.p>
      </div>
    </section>;
}